import React from "react";
import { SubscriptionStatusType } from "../../../../../types/baseTypes";
import { useTranslation } from "react-i18next";

interface Props {
  status: SubscriptionStatusType;
}

function SubscriptionStatus({ status }: Props) {
  const { t } = useTranslation();

  function subscriptionStatusLabel() {
    switch (status) {
      case "active":
        return t("subscriptions.status.active");
      case "canceled":
        return t("subscriptions.status.canceled");
      case "expired":
        return t("subscriptions.status.expired");
      case "pending":
        return t("subscriptions.status.pending");
      case "trialing":
        return t("subscriptions.status.trial");
      case "paused":
        return t("subscriptions.status.paused");
      case "failed":
        return t("subscriptions.status.failed");
      default:
        return status;
    }
  }

  const statusStyles: Record<
    SubscriptionStatusType,
    { textColor: string; bgColor: string; dotColor: string }
  > = {
    active: {
      textColor: "#2D912D",
      bgColor: "#CEEFCE",
      dotColor: "#2D912D",
    },
    canceled: {
      textColor: "#E94F54",
      bgColor: "#F8DFE5",
      dotColor: "#E94F54",
    },
    expired: {
      textColor: "#515557",
      bgColor: "#DEDFDF",
      dotColor: "#515557",
    },
    pending: {
      textColor: "#D97706",
      bgColor: "#FEF3C7",
      dotColor: "#D97706",
    },
    trialing: {
      textColor: "#7C3AED",
      bgColor: "#EDE9FE",
      dotColor: "#7C3AED",
    },
    paused: {
      textColor: "#F59E42",
      bgColor: "#FFF7E6",
      dotColor: "#F59E42",
    },
    failed: {
      textColor: "#E94F54",
      bgColor: "#F8DFE5",
      dotColor: "#E94F54",
    },
  };

  const { textColor, bgColor, dotColor } =
    statusStyles[status] || statusStyles.active;

  return (
    <div
      className="flex min-w-[90px] px-2 font-light text-sm items-center justify-center h-6 rounded-3xl"
      style={{ backgroundColor: bgColor }}
    >
      <div
        className="w-2.5 h-2.5 rounded-full mr-2.5"
        style={{ backgroundColor: dotColor }}
      />
      <div className="font-sm -mt-[2px]" style={{ color: textColor }}>
        {subscriptionStatusLabel()}
      </div>
    </div>
  );
}

export default SubscriptionStatus;